<template>
    <b-modal
        id="viewHistoryRecord"
        ref="viewHistoryRecord"
        :lazy="true"
        title="Change Log"
        no-close-on-backdrop
        :scrollable="true"
        title-tag="h2"
        hide-footer
        body-class="bg-white pr-4"
    >
        <LoaderTimeline v-if="loadContent" />
        <div v-else-if="!_.isEmpty(medicalRecordHistory) && !loadContent">
            <section
                v-for="(history, key) in medicalRecordHistory"
                :key="`${history.id}-${history.create_at.date}`"
                class="cd-container"
            >
                <div>
                    <b-row>
                        <b-col cols="2">
                            <div
                                class="timeline"
                                :class="
                                    key == medicalRecordHistory.length - 1
                                        ? 'timeline-last'
                                        : ''
                                "
                            >
                                <i
                                    class="fas fa-circle fa-xs icon-timeline"
                                ></i>
                            </div>
                        </b-col>
                        <b-col cols="10" class="timeline-content">
                            <b-row>
                                <b-col cols="6" class="p-0">
                                    <small
                                        v-if="history.create_at"
                                        class="card-title p-0"
                                    >
                                        {{
                                            _carbonDateTimeDisplay(
                                                history.create_at
                                            )
                                        }}
                                    </small>
                                </b-col>
                                <b-col
                                    v-if="
                                        history.update_by &&
                                        history.update_by.display_name
                                    "
                                    cols="6"
                                    class="p-0 text-right"
                                >
                                    <small>
                                        {{ history.update_by.display_name }}
                                    </small>
                                </b-col>
                            </b-row>
                            <b-row
                                class="pt-1"
                                :class="
                                    key != medicalRecordHistory.length - 1
                                        ? 'history-content'
                                        : ''
                                "
                            >
                                <p
                                    style="overflow-wrap: anywhere;"
                                    v-html="history.note"
                                ></p>
                            </b-row>
                        </b-col>
                    </b-row>
                </div>
            </section>
        </div>
        <div v-else-if="_.isEmpty(medicalRecordHistory) && !loadContent">
            <section class="cd-container">
                <div><i>No records available</i></div>
            </section>
        </div>
    </b-modal>
</template>
<script>
import Axios from "axios";
const baseURL = process.env.BARRAMUNDI;

export default {
    name: "viewHistoryRecord",
    components: {
        LoaderTimeline: () => import("@/components/elements/loader-timeline")
    },
    data() {
        return {
            medicalRecordHistory: [],
            loadContent: false
        };
    },
    methods: {
        open(medicalRecord) {
            let self = this;
            self.$refs.viewHistoryRecord.show();
            self.getData(medicalRecord);
        },
        getData(medicalRecord) {
            let self = this;

            self.loadContent = true;

            return Axios.get(
                `${baseURL}record/medical-record/audit-log/${medicalRecord.id}`,
                { params: { order: "desc" } }
            )
                .then(response => {
                    const historyResponse = response.data.response.resource;
                    const codeResponse = response.data.response.code;
                    if (codeResponse && codeResponse === 200) {
                        self.medicalRecordHistory = historyResponse;
                    } else {
                        throw new Error("Error fetching audit log.");
                    }
                })
                .catch(error => {
                    console.error("Error fetching audit log:", error);
                    self._message("Error fetching audit log", "danger");
                    return [];
                })
                .finally(() => {
                    self.loadContent = false;
                });
        }
    }
};
</script>
<style scoped lang="scss">
.card-title {
    font-size: 0.85rem;
    padding-top: 3%;
    color: #303e49;
}

.history-content {
    border-bottom: 1px dotted #ccc;
    margin-bottom: 1rem;
}

.timeline {
    height: 100%;
    margin-left: 50%;
    border-left: 1px solid rgba(48, 62, 73, 0.5);
}

.timeline-last {
    height: 0rem;
}

.timeline-content {
    margin-left: -15px;
    padding-right: 0px;
}

.icon-timeline {
    position: relative;
    top: -5px;
    margin-left: -0.55em;
    background-color: #ffffff;
}
</style>
